// removed by extract-text-webpack-plugin
module.exports = {"flex-tabs":"styles__flex-tabs___2gGdD","configuration-container":"styles__configuration-container___3VNRj","flex-tab":"styles__flex-tab___2_yYC","clickable":"styles__clickable___2XRef","dates":"styles__dates___30D1m"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/ImportOverview/ImportStatus/styles.scss
// module id = 7632
// module chunks = 0